import { useRule } from "../CreateRuleNew/RuleReducer";
import { Button } from "primereact/button";
import classes from "./RuleWizard.module.css";
import Button3 from "../../../Button/Button3";

const isInputPin = (pin) => pin.type === "INPUT" || pin.type === "VIRTUAL_INPUT";
const isPulsePin = (pin) => pin.type === "PULSE" || pin.type === "VIRTUAL_PULSE";

const formatMsDuration = (ms) => {
    if (ms % 3600000 === 0) return `${ms / 3600000} hour${ms === 3600000 ? "" : "s"}`;
    if (ms % 60000 === 0) return `${ms / 60000} minute${ms === 60000 ? "" : "s"}`;
    return `${ms / 1000} second${ms === 1000 ? "" : "s"}`;
};

const WizardStepDeadlineChecks = ({ pins, smartLocks, onNext, onBack }) => {
    const { state, dispatch } = useRule();

    const usedPins = new Set(
        state.conditions.filter(c => c.condition_type === "STATE_CHECK").map(c => c.pin)
    );
    const eligiblePins = pins.filter(pin => !isPulsePin(pin));
    const outputPins = eligiblePins.filter(pin => !isInputPin(pin));
    console.log(outputPins);
    const inputPins = eligiblePins.filter(isInputPin);

    const getChoice = (pin) => {
        const cond = state.conditions.find(c => c.condition_type === "STATE_CHECK" && c.pin === pin.Pin && c.is_deadline_condition);
        return cond ? cond.pin_state : null;
    };

    const setChoice = (pin, choice) => {
        const withoutThisPin = state.conditions.filter(c => !(c.condition_type === "STATE_CHECK" && c.pin === pin.Pin && c.is_deadline_condition));

        if (choice === null) {
            dispatch({ type: "SET_ADV_RULE_CONDITION", payload: withoutThisPin });
            return;
        }

        const isLock = smartLocks.some(l => parseInt(l.outputPin) === pin.Pin);
        const condition = {
            condition_type: "STATE_CHECK",
            pin: pin.Pin,
            pin_name: pin.pinName,
            pin_state: choice,
            trigger_method: "LATCH",
            trigger_method_type: "ANY",
            time_condition: "ANYTIME",
            days_of_week: ["0", "1", "2", "3", "4", "5", "6"],
            is_absence_condition: false,
            is_deadline_condition: true,
            is_lock: isLock,
            pin_status_on: pin.pinStatusOn,
            pin_status_off: pin.pinStatusOff,
        };
        dispatch({ type: "SET_ADV_RULE_CONDITION", payload: [...withoutThisPin, condition] });
    };

    const renderPinRow = (pin) => {
        const isLock = smartLocks.some(l => parseInt(l.outputPin) === pin.Pin);
        const onLabel = isLock ? "closed" : pin.pinStatusOn;
        const offLabel = isLock ? "open" : pin.pinStatusOff;
        const choice = getChoice(pin);

        return (
            <div key={pin.Pin} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px", padding: "10px 0", borderBottom: "1px solid #f0f0f0" }}>
                <p style={{ margin: 0, fontWeight: 600, fontSize: "13px", color: "#2d2d2d", flexShrink: 0 }}>{pin.pinName}</p>
                <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", justifyContent: "flex-end" }}>
                    <Button3
                        style={{
                            minWidth: "110px", minHeight: "34px", fontSize: "12px",
                            backgroundColor: choice === "ARMED" ? "var(--Primary-Color)" : undefined,
                            color: choice === "ARMED" ? "white" : undefined,
                        }}
                        onClick={() => setChoice(pin, "ARMED")}
                    >
                        {`Is in ${onLabel} status`}
                    </Button3>
                    <Button3
                        style={{
                            minWidth: "110px", minHeight: "34px", fontSize: "12px",
                            backgroundColor: choice === "DISARMED" ? "var(--Primary-Color)" : undefined,
                            color: choice === "DISARMED" ? "white" : undefined,
                        }}
                        onClick={() => setChoice(pin, "DISARMED")}
                    >
                        {`is in ${offLabel} status`}
                    </Button3>
                    <Button3
                        style={{
                            minWidth: "80px", minHeight: "34px", fontSize: "12px",
                            backgroundColor: choice === null ? "var(--Primary-Color)" : undefined,
                            color: choice === null ? "white" : undefined,
                        }}
                        onClick={() => setChoice(pin, null)}
                    >
                        Ignore
                    </Button3>
                </div>
            </div>
        );
    };

    return (
        <>
            <div className={classes.contentHeader}>
                <h2 className={classes.contentTitle}>Check any other statuses?</h2>
                <p className={classes.contentSubtitle}>
                    {state.timeframe_window_ms > 0
                        ? `Optionally require any of these to be in a given state. They are checked at the end of your ${formatMsDuration(state.timeframe_window_ms)} window.\nThe rule will only fire once the conditions have been met and the window is complete and the chosen outputs/inputs are in the defined states. Leave a switch on "Ignore" to skip it.` 
                        : "Optionally require any of these to be in a given state. They are checked at the end of your defined window (next step). The rule will only fire once this window is complete and the chosen outputs/inputs are in the defined states. Leave a switch on 'Ignore' to skip it."}
                    
                </p>
                {state.timeframe_window_ms > 0 && <p className={classes.contentSubtitle}>
                    {state.timeframe_window_mode == "FIXED" ? `\n\nBecause you chose ‘FIXED’ in the previous step, the states will be evaluated ${formatMsDuration(state.timeframe_window_ms)} after the first condition is met` :  `\n\nBecause you chose ‘SLIDING’ in the previous step, the states will be evaluated ${formatMsDuration(state.timeframe_window_ms)} after the last trigger event occurs within the original timeframe`}
                </p>}
            </div>

            <div style={{ flex: 1, overflowY: "auto", display: "flex", flexDirection: "column", gap: "18px" }}>
                {outputPins.length > 0 && (
                    <div>
                        <p style={{ color: "#9e9e9e", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", margin: "0 0 4px 0" }}>Outputs</p>
                        {outputPins.map(renderPinRow)}
                    </div>
                )}
                {inputPins.length > 0 && (
                    <div>
                        <p style={{ color: "#9e9e9e", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", margin: "0 0 4px 0" }}>Inputs</p>
                        {inputPins.map(renderPinRow)}
                    </div>
                )}
                {outputPins.length === 0 && inputPins.length === 0 && (
                    <p style={{ color: "#9e9e9e", fontSize: "13px" }}>No other switches available to check.</p>
                )}
            </div>

            <div className={classes.navRow}>
                <Button label="Back" icon="pi pi-arrow-left" severity="secondary" outlined onClick={onBack} />
                <Button label="Next" icon="pi pi-arrow-right" iconPos="right" severity="success" onClick={onNext} />
            </div>
        </>
    );
};

export default WizardStepDeadlineChecks;
